var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTractor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "40 60 180 150",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .statusFill {\n            fill: #2A6FAE;\n        }\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer3",
    transform: "matrix(10,0,0,10,-70,-70)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.57527,0,0,1.57527,7.08013,15.9043)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.028,
    cy: 5.139,
    r: 2.539,
    className: "statusFill"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.787637,0,0,0.787637,23.0401,21.9604)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.028,
    cy: 5.139,
    r: 2.539,
    className: "statusFill"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1,0,0,0.1,7,7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130,195L170,195C172.76,195 175,192.76 175,190C175,187.24 172.76,185 170,185L130,185C127.24,185 125,187.24 125,190C125,192.76 127.24,195 130,195ZM45.182,118.658C45.064,119.085 45,119.535 45,120C45,120.123 45.004,120.244 45.013,120.364C45.004,120.573 45,120.782 45,120.99C45,123.516 45,130 45,130C45,132.76 47.24,135 50,135C52.76,135 55,132.76 55,130L55,125L110,125C112.76,125 115,122.76 115,120C115,117.24 112.76,115 110,115L56.099,115L63.295,79.019C63.763,76.682 65.815,75 68.198,75L103.23,75C105.274,75 107.113,76.245 107.872,78.143L122.843,115.571C125.121,121.266 130.637,125 136.77,125L190,125C191.326,125 192.598,125.527 193.536,126.464C194.473,127.402 195,128.674 195,130C195,130 195,160 195,160C195,162.76 197.24,165 200,165C202.76,165 205,162.76 205,160L205,130C205,126.022 203.42,122.206 200.607,119.393C197.793,116.58 193.978,115 190,115L175,115L175,100C175,97.239 177.239,95 180,95L180.273,94.57C181.436,92.69 185.675,85.271 180.303,85.007L180,85C171.716,85 165,91.716 165,100L165,115L136.77,115C134.726,115 132.887,113.755 132.128,111.857L117.157,74.429C114.879,68.734 109.363,65 103.23,65L68.198,65C61.048,65 54.892,70.047 53.489,77.058C50.976,89.625 46.298,113.013 45.291,118.048C45.251,118.251 45.215,118.454 45.182,118.658ZM175,140L175,150C175,152.76 177.24,155 180,155C182.76,155 185,152.76 185,150L185,140C185,137.24 182.76,135 180,135C177.24,135 175,137.24 175,140ZM155,140L155,150C155,152.76 157.24,155 160,155C162.76,155 165,152.76 165,150L165,140C165,137.24 162.76,135 160,135C157.24,135 155,137.24 155,140ZM135,140L135,150C135,152.76 137.24,155 140,155C142.76,155 145,152.76 145,150L145,140C145,137.24 142.76,135 140,135C137.24,135 135,137.24 135,140Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTractor);
export default __webpack_public_path__ + "static/media/tractor.dadb3caa6706b68fa2f130c30756bb9b.svg";
export { ForwardRef as ReactComponent };